import type { ProjectListItem } from '../types';
import { ensureProjectPanelToggle } from './ProjectPanelToggle';
import { ProjectListView } from './project/ProjectListView';

export interface ProjectManagerCallbacks {
  onNew: () => void | Promise<void>;
  onLoad: (id: string) => void;
  onDelete: (id: string) => void;
  onRename: (id: string, newName: string) => void;
}

export class ProjectManager {
  private readonly container: HTMLElement;
  private readonly callbacks: ProjectManagerCallbacks;
  private listView: ProjectListView | null = null;

  constructor(container: HTMLElement, callbacks: ProjectManagerCallbacks) {
    this.container = container;
    this.callbacks = callbacks;
    this.renderShell();
  }

  private renderShell(): void {
    this.container.innerHTML = '';
    this.container.className = 'project-panel';

    const app = document.getElementById('app');
    if (app) {
      ensureProjectPanelToggle(app);
    }

    const header = document.createElement('div');
    header.className = 'project-header';

    const title = document.createElement('h2');
    title.textContent = 'Sessions';
    header.appendChild(title);

    const actions = document.createElement('div');
    actions.className = 'project-actions';

    const newBtn = document.createElement('button');
    newBtn.className = 'project-btn new-btn';
    newBtn.innerHTML = `
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="12" y1="5" x2="12" y2="19"/>
        <line x1="5" y1="12" x2="19" y2="12"/>
      </svg>
      New
    `;
    newBtn.addEventListener('click', () => this.callbacks.onNew());

    actions.appendChild(newBtn);
    header.appendChild(actions);

    const projectList = document.createElement('div');
    projectList.className = 'project-list';
    projectList.id = 'project-list';

    this.container.appendChild(header);
    this.container.appendChild(projectList);

    const handleLoad = (id: string): void => this.callbacks.onLoad(id);
    const handleDelete = (id: string): void => this.callbacks.onDelete(id);
    const handleRename = (id: string, newName: string): void =>
      this.callbacks.onRename(id, newName);

    this.listView = new ProjectListView(projectList, {
      onLoad: handleLoad,
      onDelete: handleDelete,
      onRename: handleRename,
    });
  }

  updateProjects(projects: ProjectListItem[]): void {
    this.listView?.setProjects(projects);
  }

  setCurrentProject(id: string | null, _name?: string): void {
    this.listView?.setCurrentProject(id);
  }

  getCurrentProjectId(): string | null {
    return this.listView?.getCurrentProjectId() ?? null;
  }
}
